'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _venues = require('redux/modules/venues');

var venueActions = _interopRequireWildcard(_venues);

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _can = require('helpers/can');

var _can2 = _interopRequireDefault(_can);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// FIXME: used temporarely to satify ImageBox required props
var nop = function nop() {
  return false;
};

var VenueForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    venue: state.venues.venue,
    image: state.venues.image,
    loaded: state.venues.loaded,
    loading: state.venues.loading,
    saving: state.venues.saving,
    saveError: state.venues.saveError,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, venueActions), null, { withRef: true }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(VenueForm, _Component);

  function VenueForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VenueForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VenueForm.__proto__ || (0, _getPrototypeOf2.default)(VenueForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      autofocus: false,
      venue: _this.props.venue,
      venueHasChanged: false,
      mapsCenter: null,
      mapsMarker: [],
      showCloseModalPopover: false,
      lockLatLon: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VenueForm, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.venueId) {
        this.setState({
          autofocus: true
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          venueId = _props.venueId,
          getVenue = _props.getVenue,
          newVenue = _props.newVenue;

      if (venueId) {
        getVenue(venueId).then(function () {
          return _this2.reloadMap();
        });
      } else {
        newVenue();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.venue !== this.props.venue) {
        this.setState({ venue: nextProps.venue });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.removeErrors();
    }
  }, {
    key: 'setMarkers',
    value: function setMarkers(mapsCenter) {
      this.setState({
        mapsCenter: mapsCenter,
        mapsMarkers: [{
          position: mapsCenter,
          defaultAnimation: null,
          key: Date.now()
        }]
      });
    }
  }, {
    key: 'showCloseModalPopover',
    value: function showCloseModalPopover() {
      this.setState({
        showCloseModalPopover: true
      });
    }
  }, {
    key: 'handleCloseModal',
    value: function handleCloseModal() {
      this.props.closeModal();
    }
  }, {
    key: 'reloadMap',
    value: function reloadMap() {
      var _this3 = this;

      var GoogleMapsAPI = window.google.maps;
      var _state = this.state,
          lockLatLon = _state.lockLatLon,
          venue = _state.venue;


      if (venue) {
        if (lockLatLon) {
          var mapsCenter = new GoogleMapsAPI.LatLng(venue.latitude, venue.longitude);
          this.setMarkers(mapsCenter);
        } else {
          var geocodeAddress = [venue.address, venue.address2, venue.city, venue.country, venue.zip].join(' ');

          if (!geocodeAddress) {
            return;
          }

          var geocoder = new GoogleMapsAPI.Geocoder();
          geocoder.geocode({ address: geocodeAddress }, function (results, status) {
            if (status === GoogleMapsAPI.GeocoderStatus.OK) {
              var _mapsCenter = results[0].geometry.location;

              var $merge = {
                $merge: {
                  latitude: _mapsCenter.lat(),
                  longitude: _mapsCenter.lng()
                }
              };
              _this3.updateVenueState((0, _reactAddonsUpdate2.default)(venue, $merge));

              _this3.setMarkers(_mapsCenter);
            }
          });
        }
      }
    }
  }, {
    key: 'updateVenueState',
    value: function updateVenueState(venue, callback) {
      this.setState({
        venue: venue,
        venueHasChanged: true
      }, function () {
        if (callback) {
          callback();
        }
      });
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this4 = this;

      var save = this.props.save;
      var venue = this.state.venue;


      save(venue).then(function (res) {
        if (res && res.type === venueActions.SAVE_SUCCESS) {
          _this4.handleCloseModal();
        }
      });
    }
  }, {
    key: 'handleChangeField',
    value: function handleChangeField(field, ev, callback) {
      var venue = this.state.venue;

      var obj = { $merge: {} };

      obj.$merge[field] = ev.target.value;

      if (this.props.saveError && (0, _keys2.default)(this.props.saveError).length !== 0) {
        this.props.removeError(venue.id, field);
      }

      this.updateVenueState((0, _reactAddonsUpdate2.default)(venue, obj), callback ? callback.bind(this) : null);
    }
  }, {
    key: 'handleChangeCcId',
    value: function handleChangeCcId(ev) {
      this.handleChangeField('cc_id', ev);
    }
  }, {
    key: 'handleChangeEbId',
    value: function handleChangeEbId(ev) {
      this.handleChangeField('eb_id', ev);
    }
  }, {
    key: 'handleChangeAddress',
    value: function handleChangeAddress(ev) {
      this.handleChangeField('address', ev, this.reloadMap);
    }
  }, {
    key: 'handleChangeAddress2',
    value: function handleChangeAddress2(ev) {
      this.handleChangeField('address2', ev, this.reloadMap);
    }
  }, {
    key: 'handleChangeBusinessHours',
    value: function handleChangeBusinessHours(businessHours) {
      var venue = this.state.venue;

      var obj = { $merge: { business_hours: businessHours } };
      this.updateVenueState((0, _reactAddonsUpdate2.default)(venue, obj));
    }
  }, {
    key: 'handleChangeCity',
    value: function handleChangeCity(ev) {
      this.handleChangeField('city', ev, this.reloadMap);
    }
  }, {
    key: 'handleChangeCountry',
    value: function handleChangeCountry(ev) {
      this.handleChangeField('country', ev, this.reloadMap);
    }
  }, {
    key: 'handleChangeDescription',
    value: function handleChangeDescription(description) {
      var venue = this.state.venue;

      var obj = { $merge: { description: description } };
      this.updateVenueState((0, _reactAddonsUpdate2.default)(venue, obj));
    }
  }, {
    key: 'handleChangeLatitude',
    value: function handleChangeLatitude(ev) {
      this.handleChangeField('latitude', ev, this.reloadMap);
    }
  }, {
    key: 'handleChangeLongitude',
    value: function handleChangeLongitude(ev) {
      this.handleChangeField('longitude', ev, this.reloadMap);
    }
  }, {
    key: 'handleChangeLockLatLon',
    value: function handleChangeLockLatLon(ev) {
      this.setState({
        lockLatLon: ev.target.checked
      });
    }
  }, {
    key: 'handleChangeName',
    value: function handleChangeName(ev) {
      this.handleChangeField('name', ev);
    }
  }, {
    key: 'handleChangeOtherNames',
    value: function handleChangeOtherNames(ev) {
      this.handleChangeField('other_names', ev);
    }
  }, {
    key: 'handleChangeOrganizations',
    value: function handleChangeOrganizations(organizations) {
      var venue = this.state.venue;

      var obj = { $merge: { organizations: organizations } };

      this.updateVenueState((0, _reactAddonsUpdate2.default)(venue, obj));
    }
  }, {
    key: 'handleChangePhone',
    value: function handleChangePhone(ev) {
      this.handleChangeField('phone', ev);
    }
  }, {
    key: 'handleChangePostalCode',
    value: function handleChangePostalCode(ev) {
      this.handleChangeField('zip', ev, this.reloadMap);
    }
  }, {
    key: 'handleChangeRegion',
    value: function handleChangeRegion(region) {
      var venue = this.state.venue;

      var obj = {
        $merge: {
          region_id: region.id,
          region: region
        }
      };
      this.updateVenueState((0, _reactAddonsUpdate2.default)(venue, obj));
    }
  }, {
    key: 'handleChangeState',
    value: function handleChangeState(ev) {
      this.handleChangeField('state', ev);
    }
  }, {
    key: 'handleChangeWebsite',
    value: function handleChangeWebsite(ev) {
      this.handleChangeField('website_url', ev);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          loaded = _props2.loaded,
          polyglot = _props2.polyglot,
          requireCloseModal = _props2.requireCloseModal,
          saving = _props2.saving,
          saveError = _props2.saveError,
          user = _props2.user;


      var isSuperAdmin = (0, _can2.default)('super_admin', [user]);

      var _state2 = this.state,
          venue = _state2.venue,
          mapsCenter = _state2.mapsCenter,
          mapsMarkers = _state2.mapsMarkers;

      var hasErrors = saveError && saveError[venue.id];
      var errorMessage = hasErrors ? polyglot.t('errors.' + saveError[venue.id].status_code) : '';
      var errorFields = hasErrors ? saveError[venue.id].errors : '';

      var popoverContainer = this;

      return _react2.default.createElement(
        _components.Loader,
        { loaded: loaded },
        _react2.default.createElement(
          'div',
          { className: 'modal-body' },
          _react2.default.createElement(
            'div',
            { className: 'venue-form' },
            _react2.default.createElement(
              _reactBootstrap.OverlayTrigger,
              {
                trigger: 'click',
                placement: 'bottom',
                rootClose: true,
                overlay: _react2.default.createElement(
                  _reactBootstrap.Popover,
                  { id: 'closeModalPopover', className: 'closeform-box-popover' },
                  _react2.default.createElement(_components.CloseModalPopover, { close: this.handleCloseModal.bind(this), save: this.handleSave.bind(this), saving: saving, scope: 'venues', polyglot: polyglot })
                )
              },
              _react2.default.createElement('button', {
                type: 'button',
                onClick: requireCloseModal,
                className: 'close-modal-button icon-cg-close'
              })
            ),
            _react2.default.createElement('input', {
              type: 'text',
              id: 'venue-title-box',
              className: 'form-control input-h1' + (errorFields && errorFields.name ? ' has-error' : ''),
              defaultValue: venue.name,
              autoFocus: this.state.autofocus,
              onChange: this.handleChangeName.bind(this),
              placeholder: polyglot.t('venues.form.name')
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-sm-5' },
                _react2.default.createElement(
                  'span',
                  { className: 'status-label label label-danger' },
                  hasErrors && errorFields && errorFields.name ? polyglot.t('' + saveError[venue.id].errors.name) : ''
                )
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-sm-4' },
                _react2.default.createElement(_components.ImageBox, { handleChangeImage: nop, handleDeleteImage: nop, polyglot: polyglot }),
                _react2.default.createElement(_components.RegionBox, {
                  errors: errorFields ? errorFields.region_id : '',
                  region: venue.region,
                  onChange: this.handleChangeRegion.bind(this),
                  popoverContainer: popoverContainer,
                  polyglot: polyglot }),
                isSuperAdmin && _react2.default.createElement(_components.GroupsBox, {
                  popoverContainer: popoverContainer,
                  onChange: this.handleChangeOrganizations.bind(this),
                  selectedOrganizations: venue.organizations,
                  errors: errorFields ? errorFields.organizations : [],
                  polyglot: polyglot
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-sm-8' },
                _react2.default.createElement(
                  'div',
                  { className: 'row' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(_components.DescriptionBox, {
                      description: venue.description,
                      onChange: this.handleChangeDescription.bind(this),
                      required: false,
                      errors: errorFields ? errorFields.description : [],
                      polyglot: polyglot
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'line-box' },
                  _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-sm-8' },
                      _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                          'label',
                          null,
                          polyglot.t('venues.form.address')
                        ),
                        _react2.default.createElement('input', {
                          placeholder: polyglot.t('venues.form.address'),
                          type: 'text',
                          id: 'venue_address',
                          className: 'form-control',
                          name: 'venue-address',
                          defaultValue: venue.address,
                          onChange: this.handleChangeAddress.bind(this)
                        })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement('input', {
                          placeholder: polyglot.t('venues.form.address2'),
                          type: 'text',
                          className: 'form-control',
                          name: 'venue-address2',
                          defaultValue: venue.address2,
                          onChange: this.handleChangeAddress2.bind(this)
                        })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                          'div',
                          { className: 'form-group col-sm-6' },
                          _react2.default.createElement(
                            'label',
                            null,
                            polyglot.t('venues.form.city')
                          ),
                          _react2.default.createElement('input', {
                            placeholder: polyglot.t('venues.form.city'),
                            type: 'text',
                            className: 'form-control',
                            name: 'venue-city',
                            defaultValue: venue.city,
                            onChange: this.handleChangeCity.bind(this)
                          })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'form-group col-sm-6' },
                          _react2.default.createElement(
                            'label',
                            null,
                            polyglot.t('venues.form.postalCode')
                          ),
                          _react2.default.createElement('input', {
                            placeholder: polyglot.t('venues.form.postalCode'),
                            type: 'text',
                            className: 'form-control',
                            name: 'venue-postal-code',
                            defaultValue: venue.zip,
                            onChange: this.handleChangePostalCode.bind(this)
                          })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                          'div',
                          { className: 'form-group col-sm-6' },
                          _react2.default.createElement(
                            'label',
                            null,
                            polyglot.t('venues.form.state')
                          ),
                          _react2.default.createElement('input', {
                            placeholder: polyglot.t('venues.form.state'),
                            type: 'text',
                            className: 'form-control',
                            name: 'venue-state',
                            defaultValue: venue.state,
                            onChange: this.handleChangeState.bind(this)
                          })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'form-group col-sm-6' },
                          _react2.default.createElement(
                            'label',
                            null,
                            polyglot.t('venues.form.country')
                          ),
                          _react2.default.createElement('input', {
                            placeholder: polyglot.t('venues.form.country'),
                            type: 'text',
                            className: 'form-control',
                            name: 'venue-country',
                            defaultValue: venue.country,
                            onChange: this.handleChangeCountry.bind(this)
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-sm-4' },
                      _react2.default.createElement(
                        'div',
                        { className: 'venue-map-box' },
                        _react2.default.createElement(_components.SimpleMap, {
                          mapsCenter: mapsCenter,
                          markers: mapsMarkers,
                          onMapClick: function onMapClick() {},
                          onMarkerRightclick: function onMarkerRightclick() {}
                        })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                          'div',
                          { className: 'form-group' },
                          _react2.default.createElement(
                            'label',
                            { className: 'control-label' },
                            polyglot.t('venues.form.lockLatLon'),
                            '\xA0'
                          ),
                          _react2.default.createElement('input', {
                            type: 'checkbox',
                            defaultValue: this.state.lockLatLon,
                            onChange: this.handleChangeLockLatLon.bind(this)
                          })
                        ),
                        this.state.lockLatLon && _react2.default.createElement(
                          'div',
                          { className: 'form-group' },
                          _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                              'div',
                              { className: 'col-sm-6' },
                              _react2.default.createElement('input', {
                                placeholder: polyglot.t('venues.form.latitude'),
                                type: 'number',
                                step: '0.0000001',
                                className: 'form-control',
                                name: 'venue-latitude',
                                defaultValue: venue.latitude,
                                onChange: this.handleChangeLatitude.bind(this)
                              })
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'col-sm-6' },
                              _react2.default.createElement('input', {
                                placeholder: polyglot.t('venues.form.longitude'),
                                type: 'number',
                                step: '0.0000001',
                                className: 'form-control',
                                name: 'venue-longitude',
                                defaultValue: venue.longitude,
                                onChange: this.handleChangeLongitude.bind(this)
                              })
                            )
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-sm-6' },
                      _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                          'label',
                          null,
                          polyglot.t('venues.form.phone')
                        ),
                        _react2.default.createElement('input', {
                          placeholder: polyglot.t('venues.form.phone'),
                          type: 'text',
                          className: 'form-control',
                          name: 'venue-phone',
                          defaultValue: venue.phone,
                          onChange: this.handleChangePhone.bind(this)
                        })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                          'label',
                          null,
                          polyglot.t('venues.form.website')
                        ),
                        _react2.default.createElement('input', {
                          placeholder: polyglot.t('venues.form.website'),
                          type: 'url',
                          className: 'form-control ' + (errorFields && errorFields.website_url ? ' has-error' : ''),
                          name: 'venue-website',
                          defaultValue: venue.website_url,
                          onChange: this.handleChangeWebsite.bind(this)
                        }),
                        _react2.default.createElement(
                          'span',
                          { className: 'status-label label label-danger' },
                          hasErrors && errorFields && errorFields.website_url ? polyglot.t('' + saveError[venue.id].errors.website_url) : ''
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                          'label',
                          null,
                          polyglot.t('venues.form.otherNames.label')
                        ),
                        _react2.default.createElement(_components.Input, {
                          placeholder: polyglot.t('venues.form.otherNames.placeholder'),
                          type: 'textarea',
                          className: 'form-control',
                          name: 'venue-other-names',
                          rows: 3,
                          defaultValue: venue.other_names,
                          required: false,
                          onChange: this.handleChangeOtherNames.bind(this) })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-sm-6' },
                      _react2.default.createElement(
                        'div',
                        { className: 'form-group business-hours' },
                        _react2.default.createElement(
                          'label',
                          null,
                          polyglot.t('venues.form.businessHours')
                        ),
                        _react2.default.createElement(_components.DescriptionBox, {
                          placeholder: polyglot.t('venues.form.businessHours'),
                          className: 'form-control',
                          name: 'venue-business-hours',
                          description: venue.business_hours,
                          required: false,
                          onChange: this.handleChangeBusinessHours.bind(this),
                          polyglot: polyglot
                        })
                      )
                    ),
                    isSuperAdmin && _react2.default.createElement(
                      'div',
                      { className: 'col-sm-12' },
                      _react2.default.createElement(
                        'div',
                        { className: 'form-group cc_id' },
                        _react2.default.createElement(
                          'label',
                          null,
                          polyglot.t('venues.form.cc_id')
                        ),
                        _react2.default.createElement('input', {
                          placeholder: polyglot.t('venues.form.cc_id'),
                          type: 'text',
                          className: 'form-control',
                          name: 'venue-cc-id',
                          defaultValue: venue.cc_id,
                          required: false,
                          onChange: this.handleChangeCcId.bind(this) })
                      )
                    ),
                    isSuperAdmin && _react2.default.createElement(
                      'div',
                      { className: 'col-sm-12' },
                      _react2.default.createElement(
                        'div',
                        { className: 'form-group eb_id' },
                        _react2.default.createElement(
                          'label',
                          null,
                          polyglot.t('venues.form.eb_id')
                        ),
                        _react2.default.createElement('input', {
                          placeholder: polyglot.t('venues.form.eb_id'),
                          type: 'text',
                          className: 'form-control',
                          name: 'venue-eb-id',
                          defaultValue: venue.eb_id,
                          required: false,
                          onChange: this.handleChangeEbId.bind(this) })
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'modal-footer' },
          _react2.default.createElement(
            'div',
            { className: 'pull-right' },
            _react2.default.createElement(
              'span',
              { className: 'status-label label label-danger' },
              errorMessage
            ),
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary',
                onClick: !saving ? this.handleSave.bind(this) : null,
                disabled: saving
              },
              saving ? _react2.default.createElement('i', { className: 'glyphicon glyphicon-refresh cg-spinner' }) : '',
              ' ',
              polyglot.t('form.save')
            )
          )
        )
      );
    }
  }]);
  return VenueForm;
}(_react.Component), _class2.propTypes = {
  closeModal: _propTypes2.default.func,
  loaded: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  save: _propTypes2.default.func.isRequired,
  venue: _propTypes2.default.object,
  venueId: _propTypes2.default.number,
  getVenue: _propTypes2.default.func,
  newVenue: _propTypes2.default.func,
  polyglot: _propTypes2.default.object.isRequired,
  requireCloseModal: _propTypes2.default.func,
  saving: _propTypes2.default.bool,
  removeErrors: _propTypes2.default.func,
  removeError: _propTypes2.default.func,
  saveError: _propTypes2.default.object,
  user: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = VenueForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Venue/VenueForm.js
// module id = 2253
// module chunks = 0